module.exports = __webpack_public_path__ + "media/images/Plus-outline-4e627dd0.svg";